/* ============================================
   Stock PDP refresh: desktop sticky Add to Cart bar alignment.
   Loaded (defer) by sections/template-product.liquid only when the section's
   "Stock PDP refresh layout" checkbox is on.

   Measures the right column (.pdp-grid-info) content box and writes its
   viewport left edge and width to --pdp-sticky-left / --pdp-sticky-width on
   #sticky-atc-bar. assets/pdp-stock-refresh.css (D11, 992px+) uses them for the
   fixed bar's left / width, so it lines up exactly with the order box. Without
   this script the CSS falls back to a calc() approximation.

   Read-only on the page: no existing JS, classes or selectors are touched; the
   bar's .active toggle stays with template-product.js.
   ============================================ */
(function () {
  var column = document.querySelector('.pdp-stock-refresh .pdp-grid-info');
  var bar = document.querySelector('.pdp-stock-refresh #sticky-atc-bar');
  if (!column || !bar) return;

  function update() {
    var rect = column.getBoundingClientRect();
    var style = window.getComputedStyle(column);
    var paddingLeft = parseFloat(style.paddingLeft) || 0;
    var paddingRight = parseFloat(style.paddingRight) || 0;
    bar.style.setProperty('--pdp-sticky-left', rect.left + paddingLeft + 'px');
    bar.style.setProperty('--pdp-sticky-width', rect.width - paddingLeft - paddingRight + 'px');
  }

  // Column size changes (breakpoints, scrollbar appearing) come through the
  // observer; above the container max-width the column only moves sideways
  // without resizing, which the window resize listener catches.
  if ('ResizeObserver' in window) {
    new ResizeObserver(update).observe(column);
  }
  window.addEventListener('resize', update);
  update();
})();

/* ============================================
   Stock PDP refresh: stock silicone minimum (form-product.liquid,
   [data-pdp-moq-note], rendered only for stock silicone with a minimum above 1).
   custom-js-product.js still owns the rule: it flags any colour entered below
   the minimum with setCustomValidity, which blocks the form submit, and keeps
   Add to Cart on "Choose Band Colors". This script listens on the form in the
   bubble phase (after custom-js-product.js's own handlers) and adds:
   - Order-box note (under Add to Cart): .is-below-min (red icon) and the error
     copy from data-error-text while any colour is short; aria-live="polite".
   - Per input: .is-below-min on its .quantity-wrapper (red outline) and
     aria-invalid="true" until the value is 0 or >= the minimum.
   - "+" from 0 (or a short value) snaps to the minimum, "-" from the minimum
     drops to 0, with a SUCCESS bubble on the snap. Skipped when the variant's
     stock (max) is below the minimum.
   - Typed short value: ERROR bubble on change (commit / blur). Value is kept.
   - Submit with a short colour: the native validation bubble is suppressed
     (preventDefault on "invalid"; the submit stays blocked) and the ERROR
     bubble shows on the first visible short input instead. A short colour on a
     hidden tab gets no bubble; the order-box note covers it.
   One bubble (appended to body) is reused for both states: one at a time,
   auto-dismiss (3s success / 4s error), Esc, outside click, or window resize.
   ============================================ */
(function () {
  var note = document.querySelector('.pdp-stock-refresh [data-pdp-moq-note]');
  if (!note) return;
  var form = note.closest('form');
  var noteText = note.querySelector('.pdp-moq-note__text');
  var min = parseInt(note.getAttribute('data-min'), 10) || 0;
  if (!form || !noteText || min < 2) return;
  var noteDefault = noteText.textContent;
  var noteError = noteText.getAttribute('data-error-text') || noteDefault;

  var COPY = {
    success: 'Minimum is ' + min + ' per color.',
    error: 'Minimum is ' + min + ' per color. Please enter ' + min + ' or more.'
  };
  var ICONS = {
    success: '<svg width="16" height="16" viewBox="0 0 16 16" focusable="false"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M4.75 8.25 7 10.5l4.25-4.75" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    error: '<svg width="16" height="16" viewBox="0 0 16 16" focusable="false"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M8 4.25v4.5" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/><circle cx="8" cy="11.4" r="1" fill="#fff"/></svg>'
  };
  var DURATION = { success: 3000, error: 4000 };

  var bubble = document.createElement('div');
  bubble.id = 'pdp-qty-bubble';
  bubble.className = 'pdp-qty-bubble';
  bubble.hidden = true;
  bubble.innerHTML = '<span class="pdp-qty-bubble__icon" aria-hidden="true"></span><span class="pdp-qty-bubble__text"></span>';
  document.body.appendChild(bubble);
  var bubbleIcon = bubble.querySelector('.pdp-qty-bubble__icon');
  var bubbleText = bubble.querySelector('.pdp-qty-bubble__text');

  var current = null; // { input, wrapper, state, describedBy }
  var dismissTimer = null;
  var hideTimer = null;
  var submitShown = false;

  function wrapperOf(input) {
    return input.closest('.quantity-wrapper') || input;
  }

  function isShort(value) {
    return value > 0 && value < min;
  }

  function hideBubble() {
    clearTimeout(dismissTimer);
    if (current) {
      current.wrapper.classList.remove('is-min-snapped');
      if (current.describedBy) {
        current.input.setAttribute('aria-describedby', current.describedBy);
      } else {
        current.input.removeAttribute('aria-describedby');
      }
      current = null;
    }
    bubble.classList.remove('is-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      if (current) return;
      bubble.hidden = true;
      bubbleText.textContent = '';
    }, 150);
  }

  function showBubble(input, state) {
    hideBubble();
    clearTimeout(hideTimer);
    var wrapper = wrapperOf(input);
    current = { input: input, wrapper: wrapper, state: state, describedBy: input.getAttribute('aria-describedby') };
    if (state === 'success') wrapper.classList.add('is-min-snapped');
    input.setAttribute('aria-describedby', (current.describedBy ? current.describedBy + ' ' : '') + bubble.id);

    // Live-region attributes go on before the text, so the text is announced.
    bubble.className = 'pdp-qty-bubble pdp-qty-bubble--' + state;
    bubble.setAttribute('role', state === 'error' ? 'alert' : 'status');
    bubble.setAttribute('aria-live', state === 'error' ? 'assertive' : 'polite');
    bubbleIcon.innerHTML = ICONS[state];
    bubbleText.textContent = '';
    bubble.hidden = false;

    var shown = current;
    setTimeout(function () {
      if (current !== shown) return;
      bubbleText.textContent = COPY[state];
      // Centred under the input's box, clamped 8px inside the viewport; the
      // pointer follows the input centre (--pdp-bubble-arrow).
      var rect = wrapper.getBoundingClientRect();
      var width = bubble.offsetWidth;
      var centre = rect.left + rect.width / 2;
      var left = Math.max(8, Math.min(centre - width / 2, document.documentElement.clientWidth - width - 8));
      bubble.style.left = left + window.pageXOffset + 'px';
      bubble.style.top = rect.bottom + window.pageYOffset + 10 + 'px';
      bubble.style.setProperty('--pdp-bubble-arrow', centre - left + 'px');
      bubble.classList.add('is-visible');
      dismissTimer = setTimeout(hideBubble, DURATION[state]);
    }, 30);
  }

  function update() {
    var below = false;
    form.querySelectorAll('[data-qty-input]').forEach(function (input) {
      var short = input.validity.customError;
      wrapperOf(input).classList.toggle('is-below-min', short);
      if (short) {
        input.setAttribute('aria-invalid', 'true');
        below = true;
      } else {
        input.removeAttribute('aria-invalid');
      }
    });
    note.classList.toggle('is-below-min', below);
    var text = below ? noteError : noteDefault;
    if (noteText.textContent !== text) noteText.textContent = text;
    // Error bubble closes once its value is fixed.
    if (current && current.state === 'error' && !current.input.validity.customError) hideBubble();
  }

  // Programmatic change: custom-js-product.js's change listener recalculates
  // validity, totals and the Add to Cart state (as after a successful add).
  function setQty(input, value) {
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  form.addEventListener('click', function (event) {
    var button = event.target.closest('.qty-btn');
    if (!button) return;
    var input = button.closest('.quantity-wrapper') && button.closest('.quantity-wrapper').querySelector('[data-qty-input]');
    if (!input || input.disabled) return;
    var value = parseInt(input.value, 10) || 0;
    var max = parseInt(input.getAttribute('max'), 10);
    if (isShort(value)) {
      if (button.classList.contains('qty-increase')) {
        if (!(max > 0 && max < min)) {
          setQty(input, min);
          showBubble(input, 'success');
        }
      } else {
        setQty(input, 0);
      }
    }
    update();
  });

  form.addEventListener('input', update);

  form.addEventListener('change', function (event) {
    var input = event.target;
    update();
    if (!event.isTrusted || !input.matches || !input.matches('[data-qty-input]')) return;
    if (isShort(parseInt(input.value, 10) || 0)) showBubble(input, 'error');
  });

  // "invalid" doesn't bubble: capture. Fires once per invalid control on submit.
  form.addEventListener('invalid', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-qty-input]') || !input.validity.customError) return;
    event.preventDefault();
    if (submitShown || input.offsetParent === null) return;
    submitShown = true;
    setTimeout(function () { submitShown = false; }, 0);
    input.focus({ preventScroll: true });
    wrapperOf(input).scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    // After the scroll so the bubble is placed against the input's new position.
    setTimeout(function () { showBubble(input, 'error'); }, 350);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && current) hideBubble();
  });
  document.addEventListener('pointerdown', function (event) {
    if (current && !bubble.contains(event.target)) hideBubble();
  });
  window.addEventListener('resize', function () {
    if (current) hideBubble();
  });

  update();
})();

/* ============================================
   Stock PDP refresh: pricing table tier highlight + sticky card height
   (co-pricing-table.liquid in .for-desk and .for__mobile; CSS in
   pdp-stock-refresh.css D13). Ported from WRW custom-js-product.js
   updateActiveTierHighlight(), adapted to CO's table, which has no tier data
   attributes: each quantity-row cell's leading number is its tier minimum
   ("25–199" -> 25, "20+" -> 20, "1+" -> 1); cells without one are skipped.

   Basis = Total Price's (custom-js-product.js updateVariantTotals /
   getDiscountAmount): the combined value of every input[name="quantity"], and
   the tier with the highest minimum <= that total. The quantity row is built
   from the same volume_discount metafield, so the highlighted column is always
   the rate Total Price charges. Nothing is highlighted at 0 or below the first
   minimum.

   Same hooks as the minimum code above: input / change / +/- clicks on the
   form, bubble phase, so custom-js-product.js's own handlers (and the snap to
   the minimum, which dispatches change) have already run.
   Adds .is-active-tier to the tier's cells in every row and aria-current="true"
   to its quantity cell, in both tables.
   ============================================ */
(function () {
  var section = document.querySelector('.pdp-stock-refresh');
  if (!section) return;
  var tables = section.querySelectorAll('.co-pricing-table');
  var form = section.querySelector('form[data-product-form]') || (tables[0] && tables[0].closest('form'));
  if (!tables.length || !form) return;

  // Tier minimum per column index (null = not a tier cell).
  var tableTiers = Array.prototype.map.call(tables, function (table) {
    var headerRow = table.querySelector('tr.co-pricing-table__header-row') || table.querySelector('tr');
    var cells = headerRow ? headerRow.querySelectorAll('td') : [];
    return Array.prototype.map.call(cells, function (cell) {
      var match = cell.textContent.trim().match(/^(\d[\d,]*)/);
      return match ? parseInt(match[1].replace(/,/g, ''), 10) : null;
    });
  });

  function totalQuantity() {
    var total = 0;
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      total += parseInt(input.value, 10) || 0;
    });
    return total;
  }

  function update() {
    var total = totalQuantity();
    tables.forEach(function (table, t) {
      var mins = tableTiers[t];
      var active = -1;
      var best = -1;
      if (total > 0) {
        mins.forEach(function (min, i) {
          if (min !== null && total >= min && min > best) {
            best = min;
            active = i;
          }
        });
      }
      table.querySelectorAll('tr').forEach(function (row, r) {
        row.querySelectorAll('td').forEach(function (cell, i) {
          var on = i === active;
          if (cell.classList.contains('is-active-tier') !== on) cell.classList.toggle('is-active-tier', on);
          if (r === 0) {
            if (on) cell.setAttribute('aria-current', 'true');
            else cell.removeAttribute('aria-current');
          }
        });
      });
    });
  }

  form.addEventListener('input', update);
  form.addEventListener('change', update);
  form.addEventListener('click', function (event) {
    if (event.target.closest('.qty-btn')) update();
  });
  update();

  // Height of whichever pricing container is visible, for scroll-padding-top.
  var root = document.documentElement;
  var containers = section.querySelectorAll('.for-desk, .for__mobile');
  function setStickyHeight() {
    var height = 0;
    containers.forEach(function (el) {
      if (el.offsetParent !== null) height = el.getBoundingClientRect().height;
    });
    root.style.setProperty('--pdp-pricing-sticky-h', Math.ceil(height) + 'px');
  }
  if ('ResizeObserver' in window) {
    var observer = new ResizeObserver(setStickyHeight);
    containers.forEach(function (el) { observer.observe(el); });
  }
  window.addEventListener('resize', setStickyHeight);
  setStickyHeight();
})();
